import { apiRequest } from "@/services/api-client";
import { MarkSeenInput, MarkSeenOutput, WebAppRoutes } from "types/web-app";

export const markSeen = (input: MarkSeenInput) =>
  apiRequest<MarkSeenOutput>("/" + WebAppRoutes.MARK_SEEN, {
    method: "POST",
    body: JSON.stringify(input),
  });
